import { useTranslation } from 'react-i18next';
import { Form, Icon, Page } from '@/components';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Space } from 'antd';
import { EditRoomOrderPanel } from '@/views/Rooms.List/EditRoomOrderPanel';
import { CommunityDetailsTabKeys } from '@/views';
import { useGetFloorplanDetailsQuery } from '@/redux';

const useId = () => {
  const { id } = useParams<'id'>();
  return id!;
};

export function EditRoomOrderPage() {
  const { t } = useTranslation();
  const title = t('rooms.editOrder');
  const push = useNavigate();
  const floorplanId = useId();
  const { data } = useGetFloorplanDetailsQuery({ id: floorplanId });

  return (
    <Page htmlTitle={title}>
      <Page.Paths>
        <Page.Path href="/communities">{t('communities.title')}</Page.Path>
        <Page.Path
          href={`/communities/${data?.communityId}#${CommunityDetailsTabKeys.floorplans}`}
        >
          {data?.communityName ?? t('fetchFallbackTitle')}
        </Page.Path>
        <Page.Path
          href={`/communities/${data?.communityId}#${CommunityDetailsTabKeys.floorplans}`}
        >
          {t('floorplans.title')}
        </Page.Path>
        <Page.Path>{title}</Page.Path>
      </Page.Paths>

      <Page.Body>
        <Page.Card
          actionsPosition="bottom"
          actions={
            <Space size="middle">
              <Button onClick={() => push(-1)}>{t('cancel')}</Button>
              <Form.Submit uid="rooms-order" type="primary">
                {t('save')}
              </Form.Submit>
            </Space>
          }
          title={title}
          icon={<Icon type="maximize" />}
          color="#107CC7"
        >
          <EditRoomOrderPanel
            floorplanId={floorplanId!}
            afterSubmit={() => push(-1)}
          />
        </Page.Card>
      </Page.Body>
    </Page>
  );
}
